
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import '@/styles/mmm-isolated.v5.css'

// Use StrictMode to catch potential issues in development
import { StrictMode } from 'react'

// Set default theme to light (based on Index page colors)
document.documentElement.classList.remove('dark');

// 🧹 LIMPAR Service Workers antigos que causam problemas
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    registrations.forEach(registration => {
      registration.unregister();
      console.log('🗑️ Service Worker desregistrado');
    });
  });
}

// 🔒 SERVICE WORKER: Temporariamente DESABILITADO para debug
// if ('serviceWorker' in navigator && window === window.top) {
//   window.addEventListener('load', () => {
//     navigator.serviceWorker.getRegistration('/').then(reg => {
//       if (!reg) {
//         console.log('🔧 Registrando Service Worker (único)');
//         navigator.serviceWorker.register('/sw.js', { scope: '/' })
//           .then(() => console.log('✅ SW registrado com sucesso'))
//           .catch(err => console.warn('⚠️ SW registration falhou:', err));
//       } else {
//         console.log('✅ Service Worker já registrado');
//       }
//     });
//   });
// }

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
